import { createGlobalStyle } from 'styled-components';
import Inter from './assets/Inter.ttf'

const GlobalStyle = createGlobalStyle`

  @font-face {
    font-family: 'Inter';
    src: url(${Inter});
  }
  
  html {
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    /* -webkit- only, deliberately: it stops iOS inflating fonts on rotation. The UNPREFIXED property
       is what Android Chrome honours, and setting it to 100% disables font boosting for users who have
       chosen a larger system text size - an accessibility regression we do not want. */
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0px;
    background-color: ${props => props.theme.colors.background};
    font-family: Inter;
    overflow: hidden;
    scrollbar-gutter: stable;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; /* For Firefox on macOS */
    font-synthesis: none !important;
  }

  /* iOS Safari zooms in on focus for any control under 16px and never zooms back out.
     Baseline for every control that does not set its own size; components that set a smaller
     size are bumped individually (class specificity beats this element selector). */
  input, textarea, select {
    font-size: 16px;
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.gray_400};
    border-radius: 6px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.colors.gray_600}; 
  }
`

export default GlobalStyle